<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="360">
      <v-card>
        <v-card-title :class="color ? color +  ' title white--text' : 'primary title white--text'">{{ title }}</v-card-title>
        <v-card-text class="py-2 px-4">{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="cancel" depressed rounded @click.native="onCancel()">取消</v-btn>
          <v-btn :color="color ? color : 'primary'" rounded depressed @click.native="onOk()">実行</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ['title', 'message', 'dialog', 'cancel', 'color'],
  data () {
    return {
    }
  },
  methods: {
    onOk () {
      this.$emit('dismissed', true)
    },
    onCancel () {
      this.$emit('dismissed', false)
    }
  }
}
</script>
